export const hasRole = (roles: string[] | undefined, role: string): boolean => {
  return (roles ?? []).some((entry) => entry.toUpperCase() === role.toUpperCase());
};

export const hasAnyRole = (roles: string[] | undefined, allowedRoles: string[]): boolean => {
  return allowedRoles.some((role) => hasRole(roles, role));
};

export const getDefaultAuthenticatedPath = (roles: string[] | undefined): string => {
  if (hasAnyRole(roles, ["ADMIN_READ", "ADMIN_WRITE"])) {
    return "/admin";
  }
  return hasRole(roles, "TEEN") ? "/gigs" : "/dashboard";
};

const getPathname = (path: string): string => {
  return path.split(/[?#]/, 1)[0].replace(/\/+$/, "") || "/";
};

export const getAuthenticatedRedirectPath = (
  roles: string[] | undefined,
  requestedRedirectPath: string | null | undefined,
): string => {
  const defaultPath = getDefaultAuthenticatedPath(roles);
  if (!hasAnyRole(roles, ["ADMIN_READ", "ADMIN_WRITE"]) && hasRole(roles, "ADULT")) {
    return requestedRedirectPath === "/dashboard?intent=post-job" ? requestedRedirectPath : defaultPath;
  }
  if (!requestedRedirectPath) {
    return defaultPath;
  }

  if (hasRole(roles, "TEEN") && getPathname(requestedRedirectPath) === "/dashboard") {
    return defaultPath;
  }

  return requestedRedirectPath;
};

export const getSafeRedirectPath = (redirect: string | null | undefined): string | null => {
  const trimmedRedirect = redirect?.trim();
  if (!trimmedRedirect || !trimmedRedirect.startsWith("/") || trimmedRedirect.startsWith("//")) {
    return null;
  }

  const pathname = getPathname(trimmedRedirect);
  if (pathname === "/login") {
    return null;
  }

  return trimmedRedirect;
};

export const isBusinessAccount = (accountType: string | null | undefined): boolean => {
  return accountType?.toUpperCase() === "BUSINESS";
};
